<template>
  <div class="imp">
    <!-- Reiter „Import" der Einstellungen — als Karten, damit weitere Import-Einstellungen andocken können -->
    <v-card class="imp-card">
      <div class="imp-card__head">
        <v-icon small class="imp-card__icon">mdi-timer-outline</v-icon>
        Auto-Import
      </div>
      <AutoImportPanel />
    </v-card>
  </div>
</template>

<script>
import AutoImportPanel from "@/components/Settings/AutoImport/AutoImportPanel";

export default {
  name: "ImportSettingsPanel",
  components: { AutoImportPanel },
};
</script>

<style lang="scss" scoped>
.imp {
  padding-bottom: 40px;
}

.imp-card {
  border-radius: 14px !important;
  padding: 18px 20px 22px;

  &__head {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  &__icon {
    margin-right: 8px;
    color: #7b5cd6 !important;
  }
}
</style>
